export const isCpf = (value) => value?.includes('Pessoa Física') || !value;
